import React from 'react'
import ApiClient from '../helpers/ApiClient';
import axios from 'axios';


export const getData = async () => {
    try {
        const response = await ApiClient.get(`/researchandstudentlife/getStudentEventsAdmin`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const addData = async (formData) => {
    try {
        const response = await ApiClient.post(`/researchandstudentlife/addStudentEvents`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const editData = async ({ id, event_name, description, date, location, file }) => {
    try {
        const response = await ApiClient.put(`/researchandstudentlife/updateStudentEvents/${id}`,
            { event_name, description, date, location, file },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const deleteData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/researchandstudentlife/deleteStudentEvents/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const addEventImages = async ({ id, file }) => {
    try {
        const response = await ApiClient.post(`/researchandstudentlife/addStudentEventImages/${id}`,
            { file },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteEventImage = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/researchandstudentlife/deleteStudentEventsImages/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}